import ErrorPage from './errorPage'

export { ErrorPage }
